var _mask, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 52 52",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "______src_modules_rwdGame_components_GameInfoPanel_svg_GameInfo_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8h36a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.1,
    d: "M0 8a8 8 0 0 1 8-8h36a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M8 2h36v-4H8zm42 6v36h4V8zm-6 42H8v4h36zM2 44V8h-4v36zm6 6a6 6 0 0 1-6-6h-4c0 5.523 4.477 10 10 10zm42-6a6 6 0 0 1-6 6v4c5.523 0 10-4.477 10-10zM44 2a6 6 0 0 1 6 6h4c0-5.523-4.477-10-10-10zM8-2C2.477-2-2 2.477-2 8h4a6 6 0 0 1 6-6z",
    mask: "url(#______src_modules_rwdGame_components_GameInfoPanel_svg_GameInfo_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M28.69 32.05c0 .675-.548 1.222-1.223 1.222h-2.933a1.222 1.222 0 0 1 0-2.444h2.933c.675 0 1.222.547 1.222 1.222m-1.344-12.1c0 .675-.548 1.222-1.223 1.222h-.244a1.222 1.222 0 0 1 0-2.444h.244c.675 0 1.223.547 1.223 1.222",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.778 25.206h-.244a1.222 1.222 0 0 1 0-2.445h.733c1.08 0 1.955.876 1.955 1.956v6.111a1.222 1.222 0 0 1-2.444 0z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26 11.333c-8.096 0-14.667 6.571-14.667 14.667S17.904 40.667 26 40.667 40.667 34.096 40.667 26 34.096 11.333 26 11.333m0 26.4c-6.468 0-11.733-5.265-11.733-11.733S19.532 14.267 26 14.267 37.733 19.532 37.733 26 32.468 37.733 26 37.733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameInfo);
export default __webpack_public_path__ + "static/media/GameInfo.36df94c7a61373aace9376e50699528f.svg";
export { ForwardRef as ReactComponent };